var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockquoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 728.45c0 138.57 112.33 250.91 250.91 250.91s250.91-112.33 250.91-250.91c0-136.87-109.64-248.07-245.87-250.78 63.348-62.125 150.11-100.5 245.87-100.5l.004-150.54c-277.14 0-501.82 224.68-501.82 501.82zm1104-501.82c-277.14 0-501.82 224.68-501.82 501.82 0 138.57 112.34 250.91 250.91 250.91S1158 867.03 1158 728.45c0-136.87-109.64-248.07-245.87-250.78 63.348-62.125 150.12-100.5 245.87-100.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "f328a34411117476e91b24f457d832a0.svg";
export { SvgBlockquoteIcon as ReactComponent };